import React from 'react';
import { GroupHighlightsPanel as GroupHighlightsPanelComponent } from '../../../../../../components/SettingsPanel/subComponents';

export default function GroupHighlightsPanel({ groupHighlights }) {
	return <GroupHighlightsPanelComponent groupHighlights={groupHighlights} />;
}
